import React, { Dispatch, SetStateAction } from 'react'

import { Modal } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import { Add } from '@mui/icons-material'
import manage from '/assets/Image/manage-wallets.png'
import click from '/assets/Image/click-arrow.png'
import CustomButton from 'components/Button/CustomButton'

export interface TopupCoachModalProps {
  TopupCoachModalOpen: boolean
  onClose: () => void
  onContinue: () => void
}

const TopupCoachModal = ({
  TopupCoachModalOpen,
  onClose,
  onContinue
}: TopupCoachModalProps) => {
  const handleClose = () => {
    onClose()
  }

  const handleContinue = () => {
    onClose()
    onContinue()
  }

  return (
    <Modal
      open={TopupCoachModalOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      className="overflow-auto modal-bg"
    >
      <div className="flex absolute top-1/2 left-1/2 flex-col justify-center items-center px-4 w-full h-full translate-x-[-50%] translate-y-[-50%]">
        <div className="flex flex-col items-center p-4 max-w-[480px] text-white bg-black1 rounded-md">
          <div className="flex w-full">
            <button
              className="flex justify-end items-end w-full cursor-pointer"
              onClick={onClose}
            >
              <Add
                style={{
                  transform: `rotate(45deg)`,
                  color: '#ffffff',
                  fontSize: '30px'
                }}
              />
            </button>
          </div>
          <p className="pb-2 text-2xl font-bold">After Top-up Tip</p>
          <p className="pb-5 text-sm text-center text-grey3">
            Once your top-up has been successful, there are two steps that you
            need to take in order for the funds to reflect in your account.
          </p>
          <div className="pb-1 font-bold text-center">
            Step 1: Go to manage your wallets from the user menu
          </div>
          <img
            src={manage}
            alt="NFT question mark logo"
            className="mx-auto mb-4 w-4/5"
          />
          <div className="pb-1 font-bold text-center">
            Step 2: Click the blue arrow to move funds to your Flow Address
          </div>
          <img
            src={click}
            alt="NFT question mark logo"
            className="mx-auto w-4/5"
          />

          {/* Add Continue button */}
          <div className="flex justify-center mt-4 w-full mb-6">
            <CustomButton
              label="Add Funds"
              model="primary"
              variant="contained"
              onClick={handleContinue}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TopupCoachModal
